/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-alert */
/* eslint-disable import/no-unresolved */
/* eslint-disable indent */
import * as React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import api from '../../services/api';
import RecaptchaService from '../../services/recaptcha';

interface IRecaptcha {
  callback: any;
}

const Recaptcha: React.FC<IRecaptcha> = ({ callback }) => {
  const recaptchaService = new RecaptchaService();
  const recaptchaRef: any = React.createRef();
  const onReCAPTCHAChange = React.useCallback(async (captchaCode: any) => {
    if (!captchaCode) {
      return;
    }
    try {
      const { data }: any = await recaptchaService.verify({
        recaptcha_response: captchaCode,
      });
      api.defaults.headers.Recaptcha = captchaCode;
      if (data?.success) {
        callback(data);
      } else {
        recaptchaRef.current.reset();
      }
    } catch (error: any) {
      console.log({ error });
      recaptchaRef.current.reset();
    }
  }, []);
  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
      onChange={onReCAPTCHAChange}
    />
  );
};

export { Recaptcha };
